import type { UserPermissions } from '@/types/directory/User';

/**
 * The permissions a user can hold, keyed by the field name on the permissions
 * payload. Referencing these instead of raw strings means a renamed permission
 * fails the build rather than silently gating nothing.
 */
export const Permission = {
    ViewResultsOfAllDepartments: 'canViewResultsOfAllDepartments',
    ViewResultsOfEmployees: 'canViewResultsOfEmployees',
    ViewDetailedResults: 'canViewDetailedResults',
    ViewComments: 'canViewComments',
    ViewCommentReplies: 'canViewCommentReplies',
    EditEvaluations: 'canEditEvaluations',
    ManageTeamPerformance: 'canManageTeamPerformance',
    ManageAllDepartmentsPerformance: 'canManageAllDepartmentsPerformance',
    ViewPerformanceProfile: 'canViewPerformanceProfile',
    ManageCompetencies: 'canManageCompetencies',
    AssignCompetencyProfiles: 'canAssignCompetencyProfiles',
    ManageCompanyValues: 'canManageCompanyValues',
    IncludeEngagementResultsInPerformanceInsights:
        'canIncludeEngagementResultsInPerformanceInsights',
    UseQuickAssessment: 'canUseQuickAssessment',
    ManageAllEmployeesObjectives: 'canManageAllEmployeesObjectives',
    EditOwnObjectives: 'canEditOwnObjectives',
    ManageTeamObjectives: 'canManageTeamObjectives',
} as const satisfies Record<string, keyof UserPermissions>;

export type PermissionValue = (typeof Permission)[keyof typeof Permission];
